
    <!--
 * 横版-全局弹窗
 * @LastEditTime: Fri Apr 04 2025 19:11:26 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_P7GW32"  :class="[`normal`,`u_c_P7GW32`]" ><div id="u_c_M0RH33"  v-show="pageData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup bind-popup`,`u_c_M0RH33`]" @click="u_c_M0RH33_event_F8M123($event)"><div id="u_c_YS3N34"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-small`,`u_c_YS3N34`]" @click="u_c_YS3N34_event_2MZ224($event)"><div id="u_c_Y8I635"  :class="[`normal popup-title popup-title-color`,`u_c_Y8I635`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_XA6837"  :class="[`normal`,`u_c_XA6837`]" ><div id="u_c_WHBH38"  :class="[`normal select-item `,`u_c_WHBH38`]" ><select id="u_c_QJ0J39"  v-model="pageData.serverItem" :class="[`normal select-item-select  server-select`,`u_c_QJ0J39`]" ><option id="u_c_VDLZ40" disabled="disabled" :value="defaultServerItem" :class="[`normal`,`u_c_VDLZ40`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_T89Y42"  :label="langData.yourServer" :class="[`normal`,`u_c_T89Y42`]" ><option id="u_c_M5IA43"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_M5IA43`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_X6ZH45"  :label="langData.allServer" :class="[`normal`,`u_c_X6ZH45`]" ><option id="u_c_IV4G46"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_IV4G46`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_H2B148"  :class="[`normal select-item`,`u_c_H2B148`]" ><select id="u_c_PS0V49"  v-model="pageData.roleIndex" :class="[`normal select-item-select `,`u_c_PS0V49`]" ><option id="u_c_I1WQ50"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_I1WQ50`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_U7QS52" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal sure submit-bind page-common-btn`,`u_c_U7QS52`]" @click="u_c_U7QS52_event_QSVC19($event)">{{`${ langData.bindBtn }`}}</a><div id="u_c_ZGGP54"  v-html="langData.canNoReBind" v-show="!pageData.canReBind" :class="[`normal txt-size tips-color`,`u_c_ZGGP54`]" ></div><a id="u_c_P8XV55" href="javascript:;" :class="[`normal popup-close bind-popup-close`,`u_c_P8XV55`]" @click="u_c_P8XV55_event_DMX517($event)"></a></div></div><div id="u_c_HOX456"  v-show="pageData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup bag-popup`,`u_c_HOX456`]" @click="u_c_HOX456_event_F8M123($event)"><div id="u_c_SEH357"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-big`,`u_c_SEH357`]" @click="u_c_SEH357_event_2MZ224($event)"><div id="u_c_WUWK58"  :class="[`normal popup-title popup-title-color`,`u_c_WUWK58`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_0N2A60"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal border-color`,`u_c_0N2A60`]" ><table id="u_c_RJAG61"  :class="[`normal`,`u_c_RJAG61`]" ><thead id="u_c_XT7N62"  :class="[`normal`,`u_c_XT7N62`]" ><td id="u_c_JJE763"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal th border-color txt-size popup-title-color`,`u_c_JJE763`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_YWH565"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal th border-color txt-size popup-title-color`,`u_c_YWH565`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_NV6867"  :class="[`normal`,`u_c_NV6867`]" ><tr id="u_c_GG2A68"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :style="`border-color:${ pageData.borderColor }`" :class="[`normal border-color tr  bag-popup-content-item`,`u_c_GG2A68`]" ><td id="u_c_TJ2C69"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal td border-color txt-size txt-color time`,`u_c_TJ2C69`]" >{{`${ packItem.award_time }`}}</td><td id="u_c_JM0B71"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal td border-color txt-size txt-color`,`u_c_JM0B71`]" ><span id="u_c_MH6772"  v-html="packItem.award_name || giftInfo[packItem.award_block] && giftInfo[packItem.award_block][+packItem.send_id - 1] && giftInfo[packItem.award_block][+packItem.send_id - 1].name || ''" :class="[`normal text`,`u_c_MH6772`]" ></span><span id="u_c_OFOF73"  v-html="`${ langData.giftCode }：${ packItem.award_code }`" v-show="packItem.send_type == 'sendSerial'" :class="[`normal award-code`,`u_c_OFOF73`]" ></span><span id="u_c_G4Z574"  v-if="packItem['send_type'] == 'sendEGift'" :class="[`normal text`,`u_c_G4Z574`]" ><div id="u_c_0R4B75"  :class="[`normal`,`u_c_0R4B75`]" ><div id="u_c_ZFJE76"  :class="[`normal`,`u_c_ZFJE76`]" >{{`${ langData.cardNumber }：`}}<div id="u_c_ZBIE78"  v-html="packItem.award_code" :class="[`normal`,`u_c_ZBIE78`]" ></div></div><div id="u_c_MTLX79"  v-if="packItem.award_secret" :class="[`normal`,`u_c_MTLX79`]" >{{`${ langData.cardPassword }：`}}<div id="u_c_S1N281"  v-html="packItem.award_secret" :class="[`normal`,`u_c_S1N281`]" ></div></div></div><a id="u_c_R3OP82" href="javascript:;" :class="[`normal txt-size popup-title-color use-award-code`,`u_c_R3OP82`]" @click="u_c_R3OP82_event_QX7K17($event,packItem.award_code,packItem.award_secret)">{{`[${ langData.copy }]`}}</a></span><a id="u_c_XRPW84" href="javascript:;" v-show="packItem['send_type'] == 'sendCoupon'" :class="[`normal popup-title-color txt-size use-quan`,`u_c_XRPW84`]" @click="u_c_XRPW84_event_1JVM17($event)">{{`[${ langData.useBtn }]`}}</a><a id="u_c_G0H986" href="javascript:;" v-show="packItem['send_type'] == 'sendSerial'" :class="[`normal txt-size popup-title-color use-award-code`,`u_c_G0H986`]" @click="u_c_G0H986_event_QX7K17($event,packItem.award_code)">{{`[${ langData.copyAndGoExchange }]`}}</a></td></tr></tbody></table><div id="u_c_TOFT88"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_TOFT88`]" ></div></div><a id="u_c_HUCL89" href="javascript:;" :class="[`normal popup-close bag-popup-close`,`u_c_HUCL89`]" @click="u_c_HUCL89_event_DMX517($event)"></a></div></div><div id="u_c_R81O90"  v-show="pageData.previewPopup == 'previewGift' || pageData.seeGiftPopupState" :class="[`normal popup award-popup`,`u_c_R81O90`]" @click="u_c_R81O90_event_TETB35($event)"><div id="u_c_KA2791"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-small`,`u_c_KA2791`]" @click="u_c_KA2791_event_U82518($event)"><div id="u_c_UR6R92"  :class="[`normal popup-title-color popup-title`,`u_c_UR6R92`]" >{{`${ langData.checkGiftBtn }`}}</div><div id="u_c_G15W94"  :class="[`normal `,`u_c_G15W94`]" ><table id="u_c_T72H95"  :class="[`normal`,`u_c_T72H95`]" ><tbody id="u_c_19OW96"  :class="[`normal`,`u_c_19OW96`]" ><tr id="u_c_TR5Q97"  v-for="(seeItem, seeIndex) in pageData.seeGift" :key="seeIndex" :style="`border-color:${ pageData.borderColor }`" :class="[`normal border-color  tr  award-popup-content`,`u_c_TR5Q97`]" ><td id="u_c_PD9I98"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal td border-color txt-size txt-color`,`u_c_PD9I98`]" ><img id="u_c_X8NX99"  :src="seeItem.pic" v-show="seeItem.pic" :class="[`normal award-popup-content-img`,`u_c_X8NX99`]" /></td><td id="u_c_XV8S100"  :style="`border-color:${ pageData.borderColor }`" :class="[`normal td border-color txt-size txt-color`,`u_c_XV8S100`]" ><div id="u_c_KKFN101"  v-html="seeItem.name" :class="[`normal award-popup-content-text`,`u_c_KKFN101`]" ></div></td></tr></tbody></table></div><a id="u_c_W6TB102" href="javascript:;" :class="[`normal popup-close award-popup-close`,`u_c_W6TB102`]" @click="u_c_W6TB102_event_DMX517($event)"></a></div></div><div id="u_c_H1YA103"  v-show="pageData.previewPopup == 'daoju' || pageData.propsPopupState" :class="[`normal popup sendVt-popup`,`u_c_H1YA103`]" @click="u_c_H1YA103_event_TETB35($event)"><div id="u_c_P7TF104"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-big`,`u_c_P7TF104`]" @click="u_c_P7TF104_event_U82518($event)"><div id="u_c_U910105"  :class="[`normal popup-title popup-title-color`,`u_c_U910105`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_YKI8107"  :class="[`normal`,`u_c_YKI8107`]" ><div id="u_c_M9F2108"  :class="[`normal`,`u_c_M9F2108`]" ><div id="u_c_R9JA109"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color award-text`,`u_c_R9JA109`]" ></div></div><img id="u_c_S75D110"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal award-img`,`u_c_S75D110`]" /></div><a id="u_c_PENZ111" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal sure  page-common-btn`,`u_c_PENZ111`]" @click="u_c_PENZ111_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_MP76113"  v-html="langData.daojuTips" v-if="!pageData.isBrandType" :class="[`normal tips-color txt-size`,`u_c_MP76113`]" ></div><a id="u_c_M9DS114" href="javascript:;" :class="[`normal popup-close sendVt-popup-close`,`u_c_M9DS114`]" @click="u_c_M9DS114_event_DMX517($event)"></a></div></div><div id="u_c_TYVL115"  v-show="pageData.previewPopup == 'multi' || pageData.multiAwardPopupState" :class="[`normal popup sendVt-popup full`,`u_c_TYVL115`]" ><div id="u_c_WU1G116"  :class="[`normal zoom-in mult-lottery-popup-bg`,`u_c_WU1G116`]" ><div id="u_c_LD7W117"  :class="[`normal mult-lottery-popup-title`,`u_c_LD7W117`]" >{{`${ langData.successTitle }`}}</div><transition-group id="u_c_J0NO119" name="fade" :class="[`normal`,`u_c_J0NO119`]" ><div id="u_c_TEXC120"  v-for="(rowItem, rowIndex) in pageData.multiAwardIconList" :key="rowIndex" :class="[`normal flex-center`,`u_c_TEXC120`]" ><div id="u_c_WBVM121"  v-for="(pic, index) in rowItem" :key="index" :class="[`normal flex-center mult-lottery-popup-reward-bg`,`u_c_WBVM121`]" ><img id="u_c_WZ2U122"  :src="pic" v-if="pic" :class="[`normal`,`u_c_WZ2U122`]" /></div></div></transition-group><a id="u_c_S0DM123" href="javascript:;" :class="[`normal full-popup-close `,`u_c_S0DM123`]" @click="u_c_S0DM123_event_DMX517($event)"></a></div></div><div id="u_c_Y4PQ124"  v-show="pageData.previewPopup == 'youhuiquan' || pageData.quanPopupState" :class="[`normal popup sendCoupon-popup`,`u_c_Y4PQ124`]" @click="u_c_Y4PQ124_event_TETB35($event)"><div id="u_c_P715125"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-big`,`u_c_P715125`]" @click="u_c_P715125_event_U82518($event)"><div id="u_c_LGOL126"  :class="[`normal popup-title popup-title-color`,`u_c_LGOL126`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_ZZNA128"  :class="[`normal`,`u_c_ZZNA128`]" ><div id="u_c_0MNO129"  :class="[`normal`,`u_c_0MNO129`]" ><div id="u_c_K4EI130"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color award-text`,`u_c_K4EI130`]" ></div></div><img id="u_c_WZCN131"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal award-img`,`u_c_WZCN131`]" /></div><a id="u_c_0NE5132" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  sure use-quan  page-common-btn`,`u_c_0NE5132`]" @click="u_c_0NE5132_event_35V252($event)">{{`${ langData.useBtn }`}}</a><a id="u_c_0I5I134" href="javascript:;" :class="[`normal popup-close sendCoupon-popup-close`,`u_c_0I5I134`]" @click="u_c_0I5I134_event_DMX517($event)"></a></div></div><div id="u_c_RY1X135"  v-show="pageData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup sendSerial-popup`,`u_c_RY1X135`]" @click="u_c_RY1X135_event_TXZS38($event)"><div id="u_c_UKY8136"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-small`,`u_c_UKY8136`]" @click="u_c_UKY8136_event_EKU139($event)"><div id="u_c_HBEC137"  :class="[`normal popup-title popup-title-color`,`u_c_HBEC137`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_SVZ9139"  :class="[`normal`,`u_c_SVZ9139`]" ><div id="u_c_IU3T140"  :class="[`normal txt-size txt-color `,`u_c_IU3T140`]" >{{`${ langData.giftCode }：`}}<span id="u_c_08QH142"  v-html="pageData.curGiftName" :class="[`normal award-code`,`u_c_08QH142`]" ></span></div><a id="u_c_WZCS143" href="javascript:;" :class="[`normal txt-size popup-title-color`,`u_c_WZCS143`]" @click="u_c_WZCS143_event_QX7K17($event)">{{`[${ langData.copy }]`}}</a></div><div id="u_c_R4XM145" href="javascript:;" :class="[`${ compData.copyTipsState ? '' : 'hide' }`,`normal txt-size txt-color`,`u_c_R4XM145`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_0LS2147" href="javascript:;" :class="[`normal popup-close sendSerial-popup-close`,`u_c_0LS2147`]" @click="u_c_0LS2147_event_KBHJ41($event)"></a><a id="u_c_S9L3148" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal sure use-award-code  page-common-btn`,`u_c_S9L3148`]" @click="u_c_S9L3148_event_YU9U68($event)">{{`${ langData.gotoExchange }`}}</a></div></div><div id="u_c_PUYJ156"  v-show="pageData.previewPopup == 'lipingka' || pageData.giftCardPopupState" :class="[`normal popup`,`u_c_PUYJ156`]" @click="u_c_PUYJ156_event_TETB35($event)"><div id="u_c_YF4A157"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-big`,`u_c_YF4A157`]" @click="u_c_YF4A157_event_U82518($event)"><div id="u_c_Y0QQ158"  :class="[`normal popup-title popup-title-color`,`u_c_Y0QQ158`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_ZKDX160"  :class="[`normal`,`u_c_ZKDX160`]" ><img id="u_c_L9ZZ161"  :src="pageData.curGiftPic" v-if="pageData.curGiftPic" :class="[`normal award-img`,`u_c_L9ZZ161`]" /><div id="u_c_NJMZ162"  :class="[`normal`,`u_c_NJMZ162`]" ><div id="u_c_JJ3M163"  :class="[`normal txt-size txt-color award-text`,`u_c_JJ3M163`]" >{{`${ langData.cardNumber }`}}<div id="u_c_XUB6165"  v-html="pageData.giftCardNumber" :class="[`normal`,`u_c_XUB6165`]" ></div></div><div id="u_c_IEXS166"  v-if="pageData.giftCardPassword" :class="[`normal txt-size txt-color award-text`,`u_c_IEXS166`]" >{{`${ langData.cardPassword }`}}<div id="u_c_WI2E168"  v-html="pageData.giftCardPassword" :class="[`normal`,`u_c_WI2E168`]" ></div></div></div></div><a id="u_c_N2HA169" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  sure use-quan  page-common-btn`,`u_c_N2HA169`]" @click="u_c_N2HA169_event_35V252($event)">{{`${ langData.copy }`}}</a><a id="u_c_T1OP171" href="javascript:;" :class="[`normal popup-close sendCoupon-popup-close`,`u_c_T1OP171`]" @click="u_c_T1OP171_event_DMX517($event)"></a></div></div><div id="u_c_QKM1172"  v-show="pageData.previewPopup == 'thanks' || pageData.thanksPopupState" :class="[`normal popup sendCoupon-popup`,`u_c_QKM1172`]" @click="u_c_QKM1172_event_TETB35($event)"><div id="u_c_R4ZN173"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-big`,`u_c_R4ZN173`]" @click="u_c_R4ZN173_event_U82518($event)"><div id="u_c_IZ85174"  :class="[`normal popup-title popup-title-color`,`u_c_IZ85174`]" >{{`${ pageData.curGiftName || langData.thanks }`}}</div><div id="u_c_MH15176"  :class="[`normal`,`u_c_MH15176`]" ><div id="u_c_HN8A177"  :class="[`normal`,`u_c_HN8A177`]" ><img id="u_c_PUUH178"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal award-img`,`u_c_PUUH178`]" /></div></div><a id="u_c_L8JS179" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  sure use-quan  page-common-btn`,`u_c_L8JS179`]" @click="u_c_L8JS179_event_35V252($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_L6TT181" href="javascript:;" :class="[`normal popup-close sendCoupon-popup-close`,`u_c_L6TT181`]" @click="u_c_L6TT181_event_DMX517($event)"></a></div></div><div id="u_c_P6VP182"  v-show="pageData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup tips-popup`,`u_c_P6VP182`]" @click="u_c_P6VP182_event_TETB35($event)"><div id="u_c_IYAW183"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-small`,`u_c_IYAW183`]" @click="u_c_IYAW183_event_U82518($event)"><div id="u_c_YR6B184"  :class="[`normal popup-title-color popup-title`,`u_c_YR6B184`]" >{{`${ pageData.tips }`}}</div><a id="u_c_GRFE186" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal sure  page-common-btn`,`u_c_GRFE186`]" @click="u_c_GRFE186_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_GOGA188" href="javascript:;" :class="[`normal popup-close`,`u_c_GOGA188`]" @click="u_c_GOGA188_event_DMX517($event)"></a></div></div><div id="u_c_BEJI19"  v-show="pageData.taskRewardPopupState" :class="[`normal popup tips-popup`,`u_c_BEJI19`]" @click="u_c_BEJI19_event_TETB35($event)"><div id="u_c_4S8G20"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-small`,`u_c_4S8G20`]" @click="u_c_4S8G20_event_U82518($event)"><div id="u_c_66TK21"  :class="[`normal popup-title-color popup-title`,`u_c_66TK21`]" >{{`${ pageData.tips }`}}</div><a id="u_c_950W25" href="javascript:;" :class="[`normal popup-close`,`u_c_950W25`]" @click="u_c_950W25_event_DMX517($event)"></a></div></div><div id="u_c_ZOEM19"  v-if="pageData.taskAwardToast" :class="[`normal `,`u_c_ZOEM19`]" ><div id="u_c_PG1V21"  :class="[`normal sub-title sub-title-bg`,`u_c_PG1V21`]" >{{`${ langData.getTaskAwardSucc }`}}</div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const curRouterCompMap = inject("curRouterCompMap",{});
    const COMP_DATA_LANG = {"default":{"copyTipsState":false,"previewPopup":`tips`,"gitfCardTutorialUrl":``},"en-US":{"copyTipsState":false,"previewPopup":`tips`,"gitfCardTutorialUrl":``},"th-TH":{"copyTipsState":false,"previewPopup":`tips`,"gitfCardTutorialUrl":``},"ru-RU":{"copyTipsState":false,"previewPopup":`tips`,"gitfCardTutorialUrl":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const {
  toClipboard
} = useClipboard();

const showTips = inject("showTips", (txt, code) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const isIosAppWebview = window?.webkit?.messageHandlers?.callSDKMethodWithParameters;

const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: ""
  },
]
const defaultRoleItem = [{
  roleID: "",
  roleName: getLangTxt("selectRole")
}]
const curPlatform = pagePlatform;

const init = () => {
  compData.bindPopupState = false
  compData.bagPopupState = false
  compData.tipsPopupState = false
  compData.propsPopupState = false
  compData.quanPopupState = false
  compData.seeGiftPopupState = false
  compData.giftCodePopupState = false
  compData.previewPopup = "";

  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)

}

init()

watch(
  () => pageData.isLogin,
  async (value) => {
    if (!value) return
    await initServerList()
    initLinkServer()
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value || !value.sid) return
    await initRoleList()
    initLinkRole()
  }
)

const initServerList = async () => {
  pageData.serverList = []
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'listServerNew'))
  if (res.result == 1) {
    res?.data?.all_servers ?
      pageData.serverList.push(...res.data.all_servers) :
      "";
    res?.data?.recent_servers ?
      pageData.recentServerList.push(...res.data.recent_servers) :
      "";
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'getMobileGameRole'), {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const bindRole = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'bind'), {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
      server_sid: pageData.serverItem.id,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(
        encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)
      ),
      server_name: pageData.serverItem.sname,
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.serverName = res.data.bind_data.server_name
    pageData.roleName = res.data.bind_data.role_name
    pageData.bindPopupState = false
    pageData.isBind = true
    try {
      window.__updatePointUploadCookie(
        "role_id",
        res.data.bind_data.role_id
      )
      window.__updatePointUploadCookie(
        "role_name",
        res.data.bind_data.role_name
      )
      window.__updatePointUploadCookie(
        "server_id",
        res.data.bind_data.server_id
      )
    } catch (error) {}
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
}

watch(() => compData.copyTipsState, value => {
  if (value) {
    setTimeout(() => {
      compData.copyTipsState = false;
    }, 2000)
  }
});
      // 绑定弹窗的click事件
      const u_c_M0RH33_event_F8M123= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_YS3N34_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_U7QS52_event_QSVC19= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
  alert(getLangTxt("selectServer"))
  return
}
if (!pageData.roleIndex) {
  alert(getLangTxt("selectRole"))
  return
}
if (!canClickBindSubmit.value) return
canClickBindSubmit.value = false
await bindRole()
canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_P8XV55_event_DMX517= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗的click事件
      const u_c_HOX456_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_SEH357_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制礼品卡信息的click事件
      const u_c_R3OP82_event_QX7K17= async (e,code,secret)=>{
        try {let copyStr = `${langData.cardNumber}：${code || ''}`
if (secret) {
  copyStr += `${langData.cardPassword}：${secret}`
}
try {
  await toClipboard(copyStr);
  showTips(langData.copySucc);
} catch (e) {}} catch (error) {console.log(error)}
      };
      // 查看的click事件
      const u_c_XRPW84_event_1JVM17= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 复制并前往的click事件
      const u_c_G0H986_event_QX7K17= async (e,code)=>{
        try {try {
  await toClipboard(code);
} catch (e) {}

bridge.open(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_HUCL89_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 查看奖励弹窗的click事件
      const u_c_R81O90_event_TETB35= async (e)=>{
        try {pageData.seeGiftPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_KA2791_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_W6TB102_event_DMX517= async (e)=>{
        try {pageData.seeGiftPopupState = false} catch (error) {console.log(error)}
      };
      // 道具领取成功弹窗的click事件
      const u_c_H1YA103_event_TETB35= async (e)=>{
        try {pageData.propsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_P7TF104_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_PENZ111_event_YU9U68= async (e)=>{
        try {pageData.propsPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_M9DS114_event_DMX517= async (e)=>{
        try {pageData.propsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_S0DM123_event_DMX517= async (e)=>{
        try {pageData.multiAwardPopupState = false
pageData.multiAwardIconList = []} catch (error) {console.log(error)}
      };
      // 优惠券领取成功弹窗的click事件
      const u_c_Y4PQ124_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_P715125_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_0NE5132_event_35V252= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_0I5I134_event_DMX517= async (e)=>{
        try {pageData.quanPopupState = false} catch (error) {console.log(error)}
      };
      // 序列号领取成功弹窗的click事件
      const u_c_RY1X135_event_TXZS38= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_UKY8136_event_EKU139= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_WZCS143_event_QX7K17= async (e)=>{
        try {await toClipboard(pageData.curGiftName);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_0LS2147_event_KBHJ41= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 前往兑换的click事件
      const u_c_S9L3148_event_YU9U68= async (e)=>{
        try {try{
  await toClipboard(pageData.curGiftName);
  compData.copyTipsState = true;
  await utils.sleep(1)
}catch(e){}

window.open(pageData.exchangeLink,"_self")} catch (error) {console.log(error)}
      };
      // 礼品卡领取成功弹窗的click事件
      const u_c_PUYJ156_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_YF4A157_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_N2HA169_event_35V252= async (e)=>{
        try {let copyStr = `${langData.cardNumber}：${pageData.giftCardNumber || ''}`

if (pageData.giftCardPassword) {
  copyStr += `${langData.cardPassword}：${pageData.giftCardPassword}`
}
try {
  await toClipboard(copyStr);
  showTips(langData.copySucc);
} catch (e) {}} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_T1OP171_event_DMX517= async (e)=>{
        try {pageData.giftCardPopupState = false} catch (error) {console.log(error)}
      };
      // 谢谢参与弹窗的click事件
      const u_c_QKM1172_event_TETB35= async (e)=>{
        try {pageData.thanksPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_R4ZN173_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_L8JS179_event_35V252= async (e)=>{
        try {pageData.thanksPopupState=false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_L6TT181_event_DMX517= async (e)=>{
        try {pageData.thanksPopupState=false} catch (error) {console.log(error)}
      };
      // 提示语弹窗的click事件
      const u_c_P6VP182_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_IYAW183_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_GRFE186_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_GOGA188_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 任务中心查看奖励弹窗的click事件
      const u_c_BEJI19_event_TETB35= async (e)=>{
        try {pageData.taskRewardPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_4S8G20_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_950W25_event_DMX517= async (e)=>{
        try {pageData.taskRewardPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_P7GW32.normal{
position:relative;
z-index:100;

}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.default{
.u_c_M0RH33.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_YS3N34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_Y8I635.normal{
position:relative;
margin-top:2.50vw;

}
}.default{
.u_c_XA6837.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_XA6837.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_XA6837.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.25vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.default{
.u_c_WHBH38.normal{
position:relative;

}
}.default{
.u_c_QJ0J39.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_VDLZ40.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_T89Y42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_M5IA43.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_X6ZH45.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_IV4G46.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_H2B148.normal{
position:relative;

}
}.default{
.u_c_PS0V49.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_I1WQ50.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_U7QS52.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
background-size:cover;
background-repeat:no-repeat;

}
}.default{
.u_c_ZGGP54.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.default{
.u_c_P8XV55.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_HOX456.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_SEH357.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_WUWK58.normal{
position:relative;
margin-top:1.20vw;

}
}.default{
.u_c_0N2A60.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.default{
.u_c_RJAG61.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_RJAG61.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_RJAG61.normal .th:last-child{
border-right:none;

}

.u_c_RJAG61.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_RJAG61.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_RJAG61.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_XT7N62.normal{
position:relative;

}
}.default{
.u_c_JJE763.normal{
position:relative;

}
}.default{
.u_c_YWH565.normal{
position:relative;

}
}.default{
.u_c_NV6867.normal{
position:relative;

}
}.default{
.u_c_GG2A68.normal{
position:relative;

}
}.default{
.u_c_TJ2C69.normal{
position:relative;

}
}.default{
.u_c_JM0B71.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_MH6772.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_OFOF73.normal{
position:relative;

}
}.default{
.u_c_G4Z574.normal{
position:relative;
white-space:pre-line;
display:flex;
align-items:center;
justify-content:justify-content;

}
}.default{
.u_c_0R4B75.normal{
position:relative;
width:100%;
height:fit-content;

}
}.default{
.u_c_ZFJE76.normal{
position:relative;

}
}.default{
.u_c_ZBIE78.normal{
position:relative;

}
}.default{
.u_c_MTLX79.normal{
position:relative;

}
}.default{
.u_c_S1N281.normal{
position:relative;

}
}.default{
.u_c_R3OP82.normal{
position:relative;
flex-shrink:0;
margin-left:0.21vw;

}
}.default{
.u_c_XRPW84.normal{
position:relative;
color:#ffac00;

}
}.default{
.u_c_G0H986.normal{
position:relative;

}
}.default{
.u_c_TOFT88.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_HUCL89.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_R81O90.normal{
position:relative;

}
}.default{
.u_c_KA2791.normal{
position:relative;

}
}.default{
.u_c_UR6R92.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.77vw;
text-align:center;
line-height:150%;

}
}.default{
.u_c_G15W94.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.default{
.u_c_T72H95.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.default{
.u_c_19OW96.normal{
position:relative;

}
}.default{
.u_c_TR5Q97.normal{
position:relative;

}
}.default{
.u_c_PD9I98.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.default{
.u_c_X8NX99.normal{
position:relative;
width:60%;

}
}.default{
.u_c_XV8S100.normal{
position:relative;
width:100%;
line-height:150%;

}
}.default{
.u_c_KKFN101.normal{
position:relative;

}
}.default{
.u_c_W6TB102.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_H1YA103.normal{
position:relative;

}
}.default{
.u_c_P7TF104.normal{
position:relative;

}
}.default{
.u_c_U910105.normal{
position:relative;
margin-top:1.61vw;

}
}.default{
.u_c_YKI8107.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_M9F2108.normal{
position:relative;

}
}.default{
.u_c_R9JA109.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_S75D110.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_PENZ111.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_MP76113.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.default{
.u_c_M9DS114.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_TYVL115.normal{
position:relative;
display:flex;
flex-direction:column;

}

.u_c_TYVL115.normal.full{
background-color:rgba(0,0,0,0.9);

}
}.default{
.u_c_WU1G116.normal{
position:relative;
margin-top:-9.11vw;
background:no-repeat center;
background-size:contain;
width:44.53vw;
height:31.41vw;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}
}.default{
.u_c_LD7W117.normal{
position:relative;
margin-top:-0.16vw;
width:100%;
margin-bottom:3.39vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_TEXC120.normal{
position:relative;
width:100%;
height:fit-content;
margin-top:1.04vw;
top:-0.16vw;

}
}.default{
.u_c_WBVM121.normal{
position:relative;
margin:0 0.63vw;
width:9.64vw;
height:9.64vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}
}.default{
.u_c_WZ2U122.normal{
position:relative;
width:80%;

}
}.default{
.u_c_S0DM123.normal{
position:absolute;
bottom:-5.21vw;
left:50%;
transform:translateX(-50%);

}
}.default{
.u_c_Y4PQ124.normal{
position:relative;

}
}.default{
.u_c_P715125.normal{
position:relative;

}
}.default{
.u_c_LGOL126.normal{
position:relative;
margin-top:1.09vw;

}
}.default{
.u_c_ZZNA128.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_0MNO129.normal{
position:relative;

}
}.default{
.u_c_K4EI130.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_WZCN131.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_0NE5132.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_0I5I134.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_RY1X135.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_UKY8136.normal{
position:relative;

}
}.default{
.u_c_HBEC137.normal{
position:relative;
margin-top:5.94vw;

}
}.default{
.u_c_SVZ9139.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.default{
.u_c_IU3T140.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.default{
.u_c_08QH142.normal{
position:relative;

}
}.default{
.u_c_WZCS143.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.default{
.u_c_R4XM145.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_R4XM145.normal.hide{
opacity:0;

}
}.default{
.u_c_0LS2147.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_S9L3148.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_PUYJ156.normal{
position:relative;

}
}.default{
.u_c_YF4A157.normal{
position:relative;

}
}.default{
.u_c_Y0QQ158.normal{
position:relative;
margin-top:1.41vw;

}
}.default{
.u_c_ZKDX160.normal{
position:relative;
height:fit-content;
overflow-y:auto;
margin-top:0.52vw;

}
}.default{
.u_c_L9ZZ161.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_NJMZ162.normal{
position:relative;

}
}.default{
.u_c_JJ3M163.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_XUB6165.normal{
position:relative;

}
}.default{
.u_c_IEXS166.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_WI2E168.normal{
position:relative;

}
}.default{
.u_c_N2HA169.normal{
position:relative;
margin:auto;
margin-top:2.08vw;

}
}.default{
.u_c_T1OP171.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_QKM1172.normal{
position:relative;

}
}.default{
.u_c_R4ZN173.normal{
position:relative;

}
}.default{
.u_c_IZ85174.normal{
position:relative;
margin-top:1.35vw;

}
}.default{
.u_c_MH15176.normal{
position:relative;
height:7.81vw;
margin-top:0.89vw;

}
}.default{
.u_c_HN8A177.normal{
position:relative;
height:100%;

}
}.default{
.u_c_PUUH178.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_L8JS179.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_L6TT181.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_P6VP182.normal{
position:relative;

}
}.default{
.u_c_IYAW183.normal{
position:relative;

}
}.default{
.u_c_YR6B184.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:9.27vw;
text-align:center;
line-height:150%;

}
}.default{
.u_c_GRFE186.normal{
position:relative;
margin:auto;
margin-top:4.79vw;
background-repeat:no-repeat;
background-size:cover;

}
}.default{
.u_c_GOGA188.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_BEJI19.normal{
position:relative;

}
}.default{
.u_c_4S8G20.normal{
position:relative;

}
}.default{
.u_c_66TK21.normal{
position:absolute;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
text-align:center;
line-height:150%;
left:50%;
top:50%;
transform:translate(-50%,-50%);
width:100%;

}
}.default{
.u_c_950W25.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.default{
.u_c_ZOEM19.normal{
position:fixed;
top:0;
bottom:0;
left:0;
right:0;

}
}.default{
.u_c_PG1V21.normal{
position:absolute;
box-sizing:border-box;
padding:1.04vw 2.08vw;
text-align:center;
width:fit-content;
top:50%;
left:50%;
transform:translate(-50%, -50%);
font-size:1.46vw;
color:#ffffff;

}
}.en-US{
.u_c_P7GW32.normal{
position:relative;
z-index:100;

}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.en-US{
.u_c_M0RH33.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_YS3N34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_Y8I635.normal{
position:relative;
margin-top:2.50vw;

}
}.en-US{
.u_c_XA6837.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_XA6837.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_XA6837.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.25vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.en-US{
.u_c_WHBH38.normal{
position:relative;

}
}.en-US{
.u_c_QJ0J39.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_VDLZ40.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_T89Y42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_M5IA43.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_X6ZH45.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_IV4G46.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_H2B148.normal{
position:relative;

}
}.en-US{
.u_c_PS0V49.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_I1WQ50.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_U7QS52.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
background-size:cover;
background-repeat:no-repeat;

}
}.en-US{
.u_c_ZGGP54.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.en-US{
.u_c_P8XV55.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_HOX456.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_SEH357.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_WUWK58.normal{
position:relative;
margin-top:1.20vw;

}
}.en-US{
.u_c_0N2A60.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.en-US{
.u_c_RJAG61.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_RJAG61.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_RJAG61.normal .th:last-child{
border-right:none;

}

.u_c_RJAG61.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_RJAG61.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_RJAG61.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_XT7N62.normal{
position:relative;

}
}.en-US{
.u_c_JJE763.normal{
position:relative;

}
}.en-US{
.u_c_YWH565.normal{
position:relative;

}
}.en-US{
.u_c_NV6867.normal{
position:relative;

}
}.en-US{
.u_c_GG2A68.normal{
position:relative;

}
}.en-US{
.u_c_TJ2C69.normal{
position:relative;

}
}.en-US{
.u_c_JM0B71.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_MH6772.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_OFOF73.normal{
position:relative;

}
}.en-US{
.u_c_G4Z574.normal{
position:relative;
white-space:pre-line;
display:flex;
align-items:center;
justify-content:justify-content;

}
}.en-US{
.u_c_0R4B75.normal{
position:relative;
width:100%;
height:fit-content;

}
}.en-US{
.u_c_ZFJE76.normal{
position:relative;

}
}.en-US{
.u_c_ZBIE78.normal{
position:relative;

}
}.en-US{
.u_c_MTLX79.normal{
position:relative;

}
}.en-US{
.u_c_S1N281.normal{
position:relative;

}
}.en-US{
.u_c_R3OP82.normal{
position:relative;
flex-shrink:0;
margin-left:0.21vw;

}
}.en-US{
.u_c_XRPW84.normal{
position:relative;
color:#ffac00;

}
}.en-US{
.u_c_G0H986.normal{
position:relative;

}
}.en-US{
.u_c_TOFT88.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_HUCL89.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_R81O90.normal{
position:relative;

}
}.en-US{
.u_c_KA2791.normal{
position:relative;

}
}.en-US{
.u_c_UR6R92.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.77vw;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_G15W94.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.en-US{
.u_c_T72H95.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.en-US{
.u_c_19OW96.normal{
position:relative;

}
}.en-US{
.u_c_TR5Q97.normal{
position:relative;

}
}.en-US{
.u_c_PD9I98.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.en-US{
.u_c_X8NX99.normal{
position:relative;
width:60%;

}
}.en-US{
.u_c_XV8S100.normal{
position:relative;
width:100%;
line-height:150%;

}
}.en-US{
.u_c_KKFN101.normal{
position:relative;

}
}.en-US{
.u_c_W6TB102.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_H1YA103.normal{
position:relative;

}
}.en-US{
.u_c_P7TF104.normal{
position:relative;

}
}.en-US{
.u_c_U910105.normal{
position:relative;
margin-top:1.61vw;

}
}.en-US{
.u_c_YKI8107.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_M9F2108.normal{
position:relative;

}
}.en-US{
.u_c_R9JA109.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_S75D110.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_PENZ111.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_MP76113.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.en-US{
.u_c_M9DS114.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_TYVL115.normal{
position:relative;
display:flex;
flex-direction:column;

}

.u_c_TYVL115.normal.full{
background-color:rgba(0,0,0,0.9);

}
}.en-US{
.u_c_WU1G116.normal{
position:relative;
margin-top:-9.11vw;
background:no-repeat center;
background-size:contain;
width:44.53vw;
height:31.41vw;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}
}.en-US{
.u_c_LD7W117.normal{
position:relative;
margin-top:-0.16vw;
width:100%;
margin-bottom:3.39vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_TEXC120.normal{
position:relative;
width:100%;
height:fit-content;
margin-top:1.04vw;
top:-0.16vw;

}
}.en-US{
.u_c_WBVM121.normal{
position:relative;
margin:0 0.63vw;
width:9.64vw;
height:9.64vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}
}.en-US{
.u_c_WZ2U122.normal{
position:relative;
width:80%;

}
}.en-US{
.u_c_S0DM123.normal{
position:absolute;
bottom:-5.21vw;
left:50%;
transform:translateX(-50%);

}
}.en-US{
.u_c_Y4PQ124.normal{
position:relative;

}
}.en-US{
.u_c_P715125.normal{
position:relative;

}
}.en-US{
.u_c_LGOL126.normal{
position:relative;
margin-top:1.09vw;

}
}.en-US{
.u_c_ZZNA128.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_0MNO129.normal{
position:relative;

}
}.en-US{
.u_c_K4EI130.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_WZCN131.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_0NE5132.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_0I5I134.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_RY1X135.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_UKY8136.normal{
position:relative;

}
}.en-US{
.u_c_HBEC137.normal{
position:relative;
margin-top:5.94vw;

}
}.en-US{
.u_c_SVZ9139.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.en-US{
.u_c_IU3T140.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.en-US{
.u_c_08QH142.normal{
position:relative;

}
}.en-US{
.u_c_WZCS143.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.en-US{
.u_c_R4XM145.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_R4XM145.normal.hide{
opacity:0;

}
}.en-US{
.u_c_0LS2147.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_S9L3148.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_PUYJ156.normal{
position:relative;

}
}.en-US{
.u_c_YF4A157.normal{
position:relative;

}
}.en-US{
.u_c_Y0QQ158.normal{
position:relative;
margin-top:1.41vw;

}
}.en-US{
.u_c_ZKDX160.normal{
position:relative;
height:fit-content;
overflow-y:auto;
margin-top:0.52vw;

}
}.en-US{
.u_c_L9ZZ161.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_NJMZ162.normal{
position:relative;

}
}.en-US{
.u_c_JJ3M163.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_XUB6165.normal{
position:relative;

}
}.en-US{
.u_c_IEXS166.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_WI2E168.normal{
position:relative;

}
}.en-US{
.u_c_N2HA169.normal{
position:relative;
margin:auto;
margin-top:2.08vw;

}
}.en-US{
.u_c_T1OP171.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_QKM1172.normal{
position:relative;

}
}.en-US{
.u_c_R4ZN173.normal{
position:relative;

}
}.en-US{
.u_c_IZ85174.normal{
position:relative;
margin-top:1.35vw;

}
}.en-US{
.u_c_MH15176.normal{
position:relative;
height:7.81vw;
margin-top:0.89vw;

}
}.en-US{
.u_c_HN8A177.normal{
position:relative;
height:100%;

}
}.en-US{
.u_c_PUUH178.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_L8JS179.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_L6TT181.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_P6VP182.normal{
position:relative;

}
}.en-US{
.u_c_IYAW183.normal{
position:relative;

}
}.en-US{
.u_c_YR6B184.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:9.27vw;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_GRFE186.normal{
position:relative;
margin:auto;
margin-top:4.79vw;
background-repeat:no-repeat;
background-size:cover;

}
}.en-US{
.u_c_GOGA188.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_BEJI19.normal{
position:relative;

}
}.en-US{
.u_c_4S8G20.normal{
position:relative;

}
}.en-US{
.u_c_66TK21.normal{
position:absolute;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
text-align:center;
line-height:150%;
left:50%;
top:50%;
transform:translate(-50%,-50%);
width:100%;

}
}.en-US{
.u_c_950W25.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_ZOEM19.normal{
position:fixed;
top:0;
bottom:0;
left:0;
right:0;

}
}.en-US{
.u_c_PG1V21.normal{
position:absolute;
box-sizing:border-box;
padding:1.04vw 2.08vw;
text-align:center;
width:fit-content;
top:50%;
left:50%;
transform:translate(-50%, -50%);
font-size:1.46vw;
color:#ffffff;

}
}.th-TH{
.u_c_P7GW32.normal{
position:relative;
z-index:100;

}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.th-TH{
.u_c_M0RH33.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_YS3N34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_Y8I635.normal{
position:relative;
margin-top:2.50vw;

}
}.th-TH{
.u_c_XA6837.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_XA6837.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_XA6837.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.25vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.th-TH{
.u_c_WHBH38.normal{
position:relative;

}
}.th-TH{
.u_c_QJ0J39.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_VDLZ40.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_T89Y42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_M5IA43.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_X6ZH45.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_IV4G46.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_H2B148.normal{
position:relative;

}
}.th-TH{
.u_c_PS0V49.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_I1WQ50.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_U7QS52.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
background-size:cover;
background-repeat:no-repeat;

}
}.th-TH{
.u_c_ZGGP54.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.th-TH{
.u_c_P8XV55.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_HOX456.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_SEH357.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_WUWK58.normal{
position:relative;
margin-top:1.20vw;

}
}.th-TH{
.u_c_0N2A60.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.th-TH{
.u_c_RJAG61.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_RJAG61.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_RJAG61.normal .th:last-child{
border-right:none;

}

.u_c_RJAG61.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_RJAG61.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_RJAG61.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_XT7N62.normal{
position:relative;

}
}.th-TH{
.u_c_JJE763.normal{
position:relative;

}
}.th-TH{
.u_c_YWH565.normal{
position:relative;

}
}.th-TH{
.u_c_NV6867.normal{
position:relative;

}
}.th-TH{
.u_c_GG2A68.normal{
position:relative;

}
}.th-TH{
.u_c_TJ2C69.normal{
position:relative;

}
}.th-TH{
.u_c_JM0B71.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_MH6772.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_OFOF73.normal{
position:relative;

}
}.th-TH{
.u_c_G4Z574.normal{
position:relative;
white-space:pre-line;
display:flex;
align-items:center;
justify-content:justify-content;

}
}.th-TH{
.u_c_0R4B75.normal{
position:relative;
width:100%;
height:fit-content;

}
}.th-TH{
.u_c_ZFJE76.normal{
position:relative;

}
}.th-TH{
.u_c_ZBIE78.normal{
position:relative;

}
}.th-TH{
.u_c_MTLX79.normal{
position:relative;

}
}.th-TH{
.u_c_S1N281.normal{
position:relative;

}
}.th-TH{
.u_c_R3OP82.normal{
position:relative;
flex-shrink:0;
margin-left:0.21vw;

}
}.th-TH{
.u_c_XRPW84.normal{
position:relative;
color:#ffac00;

}
}.th-TH{
.u_c_G0H986.normal{
position:relative;

}
}.th-TH{
.u_c_TOFT88.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_HUCL89.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_R81O90.normal{
position:relative;

}
}.th-TH{
.u_c_KA2791.normal{
position:relative;

}
}.th-TH{
.u_c_UR6R92.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.77vw;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_G15W94.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.th-TH{
.u_c_T72H95.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.th-TH{
.u_c_19OW96.normal{
position:relative;

}
}.th-TH{
.u_c_TR5Q97.normal{
position:relative;

}
}.th-TH{
.u_c_PD9I98.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.th-TH{
.u_c_X8NX99.normal{
position:relative;
width:60%;

}
}.th-TH{
.u_c_XV8S100.normal{
position:relative;
width:100%;
line-height:150%;

}
}.th-TH{
.u_c_KKFN101.normal{
position:relative;

}
}.th-TH{
.u_c_W6TB102.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_H1YA103.normal{
position:relative;

}
}.th-TH{
.u_c_P7TF104.normal{
position:relative;

}
}.th-TH{
.u_c_U910105.normal{
position:relative;
margin-top:1.61vw;

}
}.th-TH{
.u_c_YKI8107.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.th-TH{
.u_c_M9F2108.normal{
position:relative;

}
}.th-TH{
.u_c_R9JA109.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_S75D110.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_PENZ111.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_MP76113.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.th-TH{
.u_c_M9DS114.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_TYVL115.normal{
position:relative;
display:flex;
flex-direction:column;

}

.u_c_TYVL115.normal.full{
background-color:rgba(0,0,0,0.9);

}
}.th-TH{
.u_c_WU1G116.normal{
position:relative;
margin-top:-9.11vw;
background:no-repeat center;
background-size:contain;
width:44.53vw;
height:31.41vw;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}
}.th-TH{
.u_c_LD7W117.normal{
position:relative;
margin-top:-0.16vw;
width:100%;
margin-bottom:3.39vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_TEXC120.normal{
position:relative;
width:100%;
height:fit-content;
margin-top:1.04vw;
top:-0.16vw;

}
}.th-TH{
.u_c_WBVM121.normal{
position:relative;
margin:0 0.63vw;
width:9.64vw;
height:9.64vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}
}.th-TH{
.u_c_WZ2U122.normal{
position:relative;
width:80%;

}
}.th-TH{
.u_c_S0DM123.normal{
position:absolute;
bottom:-5.21vw;
left:50%;
transform:translateX(-50%);

}
}.th-TH{
.u_c_Y4PQ124.normal{
position:relative;

}
}.th-TH{
.u_c_P715125.normal{
position:relative;

}
}.th-TH{
.u_c_LGOL126.normal{
position:relative;
margin-top:1.09vw;

}
}.th-TH{
.u_c_ZZNA128.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.th-TH{
.u_c_0MNO129.normal{
position:relative;

}
}.th-TH{
.u_c_K4EI130.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_WZCN131.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_0NE5132.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_0I5I134.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_RY1X135.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_UKY8136.normal{
position:relative;

}
}.th-TH{
.u_c_HBEC137.normal{
position:relative;
margin-top:5.94vw;

}
}.th-TH{
.u_c_SVZ9139.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.th-TH{
.u_c_IU3T140.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.th-TH{
.u_c_08QH142.normal{
position:relative;

}
}.th-TH{
.u_c_WZCS143.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.th-TH{
.u_c_R4XM145.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_R4XM145.normal.hide{
opacity:0;

}
}.th-TH{
.u_c_0LS2147.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_S9L3148.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_PUYJ156.normal{
position:relative;

}
}.th-TH{
.u_c_YF4A157.normal{
position:relative;

}
}.th-TH{
.u_c_Y0QQ158.normal{
position:relative;
margin-top:1.41vw;

}
}.th-TH{
.u_c_ZKDX160.normal{
position:relative;
height:fit-content;
overflow-y:auto;
margin-top:0.52vw;

}
}.th-TH{
.u_c_L9ZZ161.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_NJMZ162.normal{
position:relative;

}
}.th-TH{
.u_c_JJ3M163.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_XUB6165.normal{
position:relative;

}
}.th-TH{
.u_c_IEXS166.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_WI2E168.normal{
position:relative;

}
}.th-TH{
.u_c_N2HA169.normal{
position:relative;
margin:auto;
margin-top:2.08vw;

}
}.th-TH{
.u_c_T1OP171.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_QKM1172.normal{
position:relative;

}
}.th-TH{
.u_c_R4ZN173.normal{
position:relative;

}
}.th-TH{
.u_c_IZ85174.normal{
position:relative;
margin-top:1.35vw;

}
}.th-TH{
.u_c_MH15176.normal{
position:relative;
height:7.81vw;
margin-top:0.89vw;

}
}.th-TH{
.u_c_HN8A177.normal{
position:relative;
height:100%;

}
}.th-TH{
.u_c_PUUH178.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_L8JS179.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_L6TT181.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_P6VP182.normal{
position:relative;

}
}.th-TH{
.u_c_IYAW183.normal{
position:relative;

}
}.th-TH{
.u_c_YR6B184.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:9.27vw;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_GRFE186.normal{
position:relative;
margin:auto;
margin-top:4.79vw;
background-repeat:no-repeat;
background-size:cover;

}
}.th-TH{
.u_c_GOGA188.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_BEJI19.normal{
position:relative;

}
}.th-TH{
.u_c_4S8G20.normal{
position:relative;

}
}.th-TH{
.u_c_66TK21.normal{
position:absolute;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
text-align:center;
line-height:150%;
left:50%;
top:50%;
transform:translate(-50%,-50%);
width:100%;

}
}.th-TH{
.u_c_950W25.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_ZOEM19.normal{
position:fixed;
top:0;
bottom:0;
left:0;
right:0;

}
}.th-TH{
.u_c_PG1V21.normal{
position:absolute;
box-sizing:border-box;
padding:1.04vw 2.08vw;
text-align:center;
width:fit-content;
top:50%;
left:50%;
transform:translate(-50%, -50%);
font-size:1.46vw;
color:#ffffff;

}
}.ru-RU{
.u_c_P7GW32.normal{
position:relative;
z-index:100;

}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.ru-RU{
.u_c_M0RH33.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_YS3N34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_Y8I635.normal{
position:relative;
margin-top:2.50vw;

}
}.ru-RU{
.u_c_XA6837.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_XA6837.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_XA6837.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.25vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.ru-RU{
.u_c_WHBH38.normal{
position:relative;

}
}.ru-RU{
.u_c_QJ0J39.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_VDLZ40.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_T89Y42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_M5IA43.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_X6ZH45.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_IV4G46.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_H2B148.normal{
position:relative;

}
}.ru-RU{
.u_c_PS0V49.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_I1WQ50.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_U7QS52.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
background-size:cover;
background-repeat:no-repeat;

}
}.ru-RU{
.u_c_ZGGP54.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.ru-RU{
.u_c_P8XV55.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_HOX456.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_SEH357.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_WUWK58.normal{
position:relative;
margin-top:1.20vw;

}
}.ru-RU{
.u_c_0N2A60.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.ru-RU{
.u_c_RJAG61.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_RJAG61.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_RJAG61.normal .th:last-child{
border-right:none;

}

.u_c_RJAG61.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_RJAG61.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_RJAG61.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_XT7N62.normal{
position:relative;

}
}.ru-RU{
.u_c_JJE763.normal{
position:relative;

}
}.ru-RU{
.u_c_YWH565.normal{
position:relative;

}
}.ru-RU{
.u_c_NV6867.normal{
position:relative;

}
}.ru-RU{
.u_c_GG2A68.normal{
position:relative;

}
}.ru-RU{
.u_c_TJ2C69.normal{
position:relative;

}
}.ru-RU{
.u_c_JM0B71.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_MH6772.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_OFOF73.normal{
position:relative;

}
}.ru-RU{
.u_c_G4Z574.normal{
position:relative;
white-space:pre-line;
display:flex;
align-items:center;
justify-content:justify-content;

}
}.ru-RU{
.u_c_0R4B75.normal{
position:relative;
width:100%;
height:fit-content;

}
}.ru-RU{
.u_c_ZFJE76.normal{
position:relative;

}
}.ru-RU{
.u_c_ZBIE78.normal{
position:relative;

}
}.ru-RU{
.u_c_MTLX79.normal{
position:relative;

}
}.ru-RU{
.u_c_S1N281.normal{
position:relative;

}
}.ru-RU{
.u_c_R3OP82.normal{
position:relative;
flex-shrink:0;
margin-left:0.21vw;

}
}.ru-RU{
.u_c_XRPW84.normal{
position:relative;
color:#ffac00;

}
}.ru-RU{
.u_c_G0H986.normal{
position:relative;

}
}.ru-RU{
.u_c_TOFT88.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_HUCL89.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_R81O90.normal{
position:relative;

}
}.ru-RU{
.u_c_KA2791.normal{
position:relative;

}
}.ru-RU{
.u_c_UR6R92.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.77vw;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_G15W94.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.ru-RU{
.u_c_T72H95.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ru-RU{
.u_c_19OW96.normal{
position:relative;

}
}.ru-RU{
.u_c_TR5Q97.normal{
position:relative;

}
}.ru-RU{
.u_c_PD9I98.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.ru-RU{
.u_c_X8NX99.normal{
position:relative;
width:60%;

}
}.ru-RU{
.u_c_XV8S100.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ru-RU{
.u_c_KKFN101.normal{
position:relative;

}
}.ru-RU{
.u_c_W6TB102.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_H1YA103.normal{
position:relative;

}
}.ru-RU{
.u_c_P7TF104.normal{
position:relative;

}
}.ru-RU{
.u_c_U910105.normal{
position:relative;
margin-top:1.61vw;

}
}.ru-RU{
.u_c_YKI8107.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ru-RU{
.u_c_M9F2108.normal{
position:relative;

}
}.ru-RU{
.u_c_R9JA109.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_S75D110.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_PENZ111.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_MP76113.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.ru-RU{
.u_c_M9DS114.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_TYVL115.normal{
position:relative;
display:flex;
flex-direction:column;

}

.u_c_TYVL115.normal.full{
background-color:rgba(0,0,0,0.9);

}
}.ru-RU{
.u_c_WU1G116.normal{
position:relative;
margin-top:-9.11vw;
background:no-repeat center;
background-size:contain;
width:44.53vw;
height:31.41vw;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}
}.ru-RU{
.u_c_LD7W117.normal{
position:relative;
margin-top:-0.16vw;
width:100%;
margin-bottom:3.39vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_TEXC120.normal{
position:relative;
width:100%;
height:fit-content;
margin-top:1.04vw;
top:-0.16vw;

}
}.ru-RU{
.u_c_WBVM121.normal{
position:relative;
margin:0 0.63vw;
width:9.64vw;
height:9.64vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}
}.ru-RU{
.u_c_WZ2U122.normal{
position:relative;
width:80%;

}
}.ru-RU{
.u_c_S0DM123.normal{
position:absolute;
bottom:-5.21vw;
left:50%;
transform:translateX(-50%);

}
}.ru-RU{
.u_c_Y4PQ124.normal{
position:relative;

}
}.ru-RU{
.u_c_P715125.normal{
position:relative;

}
}.ru-RU{
.u_c_LGOL126.normal{
position:relative;
margin-top:1.09vw;

}
}.ru-RU{
.u_c_ZZNA128.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ru-RU{
.u_c_0MNO129.normal{
position:relative;

}
}.ru-RU{
.u_c_K4EI130.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_WZCN131.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_0NE5132.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_0I5I134.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_RY1X135.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_UKY8136.normal{
position:relative;

}
}.ru-RU{
.u_c_HBEC137.normal{
position:relative;
margin-top:5.94vw;

}
}.ru-RU{
.u_c_SVZ9139.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.ru-RU{
.u_c_IU3T140.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.ru-RU{
.u_c_08QH142.normal{
position:relative;

}
}.ru-RU{
.u_c_WZCS143.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.ru-RU{
.u_c_R4XM145.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_R4XM145.normal.hide{
opacity:0;

}
}.ru-RU{
.u_c_0LS2147.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_S9L3148.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_PUYJ156.normal{
position:relative;

}
}.ru-RU{
.u_c_YF4A157.normal{
position:relative;

}
}.ru-RU{
.u_c_Y0QQ158.normal{
position:relative;
margin-top:1.41vw;

}
}.ru-RU{
.u_c_ZKDX160.normal{
position:relative;
height:fit-content;
overflow-y:auto;
margin-top:0.52vw;

}
}.ru-RU{
.u_c_L9ZZ161.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_NJMZ162.normal{
position:relative;

}
}.ru-RU{
.u_c_JJ3M163.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_XUB6165.normal{
position:relative;

}
}.ru-RU{
.u_c_IEXS166.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_WI2E168.normal{
position:relative;

}
}.ru-RU{
.u_c_N2HA169.normal{
position:relative;
margin:auto;
margin-top:2.08vw;

}
}.ru-RU{
.u_c_T1OP171.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_QKM1172.normal{
position:relative;

}
}.ru-RU{
.u_c_R4ZN173.normal{
position:relative;

}
}.ru-RU{
.u_c_IZ85174.normal{
position:relative;
margin-top:1.35vw;

}
}.ru-RU{
.u_c_MH15176.normal{
position:relative;
height:7.81vw;
margin-top:0.89vw;

}
}.ru-RU{
.u_c_HN8A177.normal{
position:relative;
height:100%;

}
}.ru-RU{
.u_c_PUUH178.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_L8JS179.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_L6TT181.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_P6VP182.normal{
position:relative;

}
}.ru-RU{
.u_c_IYAW183.normal{
position:relative;

}
}.ru-RU{
.u_c_YR6B184.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:9.27vw;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_GRFE186.normal{
position:relative;
margin:auto;
margin-top:4.79vw;
background-repeat:no-repeat;
background-size:cover;

}
}.ru-RU{
.u_c_GOGA188.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_BEJI19.normal{
position:relative;

}
}.ru-RU{
.u_c_4S8G20.normal{
position:relative;

}
}.ru-RU{
.u_c_66TK21.normal{
position:absolute;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
text-align:center;
line-height:150%;
left:50%;
top:50%;
transform:translate(-50%,-50%);
width:100%;

}
}.ru-RU{
.u_c_950W25.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_ZOEM19.normal{
position:fixed;
top:0;
bottom:0;
left:0;
right:0;

}
}.ru-RU{
.u_c_PG1V21.normal{
position:absolute;
box-sizing:border-box;
padding:1.04vw 2.08vw;
text-align:center;
width:fit-content;
top:50%;
left:50%;
transform:translate(-50%, -50%);
font-size:1.46vw;
color:#ffffff;

}
}
</style>
